/**
 * Orquestrador único de unload: hooks de behavior + beacon da fila.
 */

import { flushQueueWithBeacon, setUnloadingFlag } from './queue';

const hooks: Array<() => void> = [];
let attached = false;

export function registerUnloadHook(fn: () => void): () => void {
  hooks.push(fn);
  return () => {
    const i = hooks.indexOf(fn);
    if (i >= 0) hooks.splice(i, 1);
  };
}

export function runUnloadDelivery(): void {
  setUnloadingFlag(true);
  for (const fn of hooks) {
    try {
      fn();
    } catch {
      // noop
    }
  }
  flushQueueWithBeacon();
  setUnloadingFlag(false);
}

export function setupUnifiedUnloadFlush(): void {
  if (typeof document === 'undefined' || typeof window === 'undefined' || attached)
    return;
  attached = true;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') runUnloadDelivery();
  });
  window.addEventListener('beforeunload', () => runUnloadDelivery());
}
